module.exports = __webpack_public_path__ + "static/media/mm-logo--large.572794c1.svg";